export const enum EUserTags {
  ADMIN_USER_ROLES = 'adminUserRoles',
  USER_BY_ID = 'userById',
  GLOBAL_USERS_DATA = 'globalUsersData',
  BLOCKED_USERS = 'blockedUsers'
}

export type TAdminUserRolesParams = {
  district: string;
};

export type TUserByIdParams = {
  district: string;
  id: number;
};

export type TGlobalAuthUserParams = {
  userId: string;
};

export type TBlockedUserGetParams = {
  district: string;
};

export type TBlockUserParams = {
  userId: number;
  district: string;
};

export type TUnblockUserParams = {
  id: number;
  district: string;
};
